"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryProcessQuestion = exports.Summary = exports.FinishProcessQuestion = exports.SummaryComponent = exports.ProcessQuestions = void 0;
/* eslint-disable jsx-a11y/label-has-for */
/** @jsx jsx */
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const core_1 = require("@emotion/core");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const forms_1 = require("@/forms");
const api_payloads_1 = require("@/redux/api-payloads");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const ProcessQuestions = ({ questions, programId, sectionId, processQuestionId, }) => {
    const [activeQuestionIdx, setActiveQuestion] = react_1.useState(0);
    const [answers, setAnswer] = react_1.useState([]);
    const activeQuestion = questions[activeQuestionIdx];
    const lastQuestion = activeQuestionIdx + 1 === questions.length;
    const onBackPress = () => setActiveQuestion(activeQuestionIdx - 1);
    const initialValues = answers.reduce((acc, curr, idx) => {
        acc[`answer-${idx}`] = curr;
        return acc;
    }, {});
    if (activeQuestion) {
        return (core_1.jsx("div", { className: styles_scss_1.default.processQuestionsLayout },
            core_1.jsx("div", { className: styles_scss_1.default.header },
                core_1.jsx("img", { src: constants_1.Images.yellowBookIcon, alt: "book" }),
                core_1.jsx("h3", null, constants_1.default.program.processQuestions)),
            core_1.jsx("div", { className: styles_scss_1.default.content },
                core_1.jsx("div", null,
                    core_1.jsx("label", null, constants_1.default.program.questionsOf(activeQuestionIdx + 1, questions.length)),
                    core_1.jsx("div", { className: styles_scss_1.default.wording }, activeQuestion.wording)),
                core_1.jsx(forms_1.QuestionsForm, { questions: questions, submitTitle: lastQuestion ? constants_1.default.general.finish : constants_1.default.general.next, activeQuestionIdx: activeQuestionIdx, initialValues: initialValues, setAnswer: (data) => {
                        setActiveQuestion(activeQuestionIdx + 1);
                        const newAnswers = [...answers];
                        newAnswers[activeQuestionIdx] = data[`answer-${activeQuestionIdx}`];
                        setAnswer(newAnswers);
                    }, onBackPress: onBackPress, placeholder: activeQuestion === null || activeQuestion === void 0 ? void 0 : activeQuestion.placeholder }))));
    }
    return (core_1.jsx(exports.Summary, { answers: answers, questions: questions, createPayload: () => api_payloads_1.answerQuestionsPayload(programId, sectionId, processQuestionId, answers, questions), onBackPress: onBackPress }));
};
exports.ProcessQuestions = ProcessQuestions;
const SummaryComponent = ({ answers, questions, createPayload, makeRequest, onBackPress, }) => (core_1.jsx("div", { className: styles_scss_1.default.summaryLayout },
    core_1.jsx("div", { className: styles_scss_1.default.header },
        core_1.jsx("img", { src: constants_1.Images.yellowBookIcon, alt: "book" }),
        core_1.jsx("h3", null, constants_1.default.program.processQuestions)),
    core_1.jsx("div", { className: styles_scss_1.default.content },
        core_1.jsx("div", null,
            core_1.jsx("h4", { className: styles_scss_1.default.summary }, constants_1.default.program.summary),
            core_1.jsx("div", { className: styles_scss_1.default.summaryText }, constants_1.default.program.hereIsASummary),
            core_1.jsx(components_1.Banner, { description: constants_1.default.program.rememberThatOnce, backgroundColor: styles_scss_1.default.primary01, icon: constants_1.Images.bannerInfoIcon }),
            core_1.jsx("div", { className: styles_scss_1.default.questionContainer }, questions.map((q, idx) => (core_1.jsx("div", { className: styles_scss_1.default.question, key: q.id },
                core_1.jsx("label", null, constants_1.default.program.questionsOf(idx + 1, questions.length)),
                core_1.jsx("div", { className: styles_scss_1.default.questionWording }, q.wording),
                core_1.jsx("div", { className: styles_scss_1.default.answers }, answers[idx])))))),
        core_1.jsx("div", { className: styles_scss_1.default.buttonContainer },
            core_1.jsx(components_1.Button, { className: styles_scss_1.default.button, title: constants_1.default.general.back, ariaLabel: constants_1.default.general.back, variant: "ghost", onClick: onBackPress }),
            core_1.jsx(components_1.Button, { className: styles_scss_1.default.submitButton, title: constants_1.default.program.submit, ariaLabel: constants_1.default.program.submit, onClick: () => {
                    makeRequest(createPayload());
                } })))));
exports.SummaryComponent = SummaryComponent;
const FinishProcessQuestion = ({ onContinue }) => (core_1.jsx("div", { className: styles_scss_1.default.finishProcessQuestionLayout },
    core_1.jsx("img", { src: constants_1.Images.processComplete, alt: "Process complete" }),
    core_1.jsx("div", { className: styles_scss_1.default.textContainer },
        core_1.jsx("h2", null, constants_1.default.program.greatJob),
        core_1.jsx("div", { className: styles_scss_1.default.text }, constants_1.default.program.thanksForSubmitting),
        core_1.jsx(components_1.Button, { variant: "secondary", ariaLabel: "Complete process questions", title: constants_1.default.program.continueToTheNext, onClick: onContinue }))));
exports.FinishProcessQuestion = FinishProcessQuestion;
const mapDispatchToProps = (dispatch) => ({
    makeRequest: (payload) => dispatch(radio_dispatch_1.reduxSet.makeRequest.dispatch(payload)),
});
exports.Summary = react_redux_1.connect(() => ({}), mapDispatchToProps)(exports.SummaryComponent);
const SummaryProcessQuestion = ({ questions, onContinue }) => (core_1.jsx("div", { className: styles_scss_1.default.summaryLayout },
    core_1.jsx("div", { className: styles_scss_1.default.header },
        core_1.jsx("img", { src: constants_1.Images.yellowBookIcon, alt: "book" }),
        core_1.jsx("h3", null, constants_1.default.program.processQuestions),
        core_1.jsx(components_1.Button, { className: styles_scss_1.default.doneButtonDesktop, title: constants_1.default.program.done, ariaLabel: constants_1.default.program.done, variant: "primary", onClick: onContinue })),
    core_1.jsx("div", { className: styles_scss_1.default.content },
        core_1.jsx("div", { className: styles_scss_1.default.summaryContainer },
            core_1.jsx("h4", { className: styles_scss_1.default.summary }, constants_1.default.program.myAnswers),
            core_1.jsx("div", { className: styles_scss_1.default.questionContainer }, questions.map((q, idx) => (core_1.jsx("div", { className: styles_scss_1.default.question, key: q.id },
                core_1.jsx("label", null, constants_1.default.program.questionsOf(idx + 1, questions.length)),
                core_1.jsx("div", { className: styles_scss_1.default.questionWording }, q.wording),
                core_1.jsx("div", { color: styles_scss_1.default.darkGrey }, q.answer)))))),
        core_1.jsx("div", { className: styles_scss_1.default.buttonContainer },
            core_1.jsx(components_1.Button, { className: styles_scss_1.default.doneButton, title: constants_1.default.program.done, ariaLabel: constants_1.default.program.done, variant: "primary", onClick: onContinue })))));
exports.SummaryProcessQuestion = SummaryProcessQuestion;
